import { ClerkProvider } from '@clerk/nextjs'

import ErrorBoundary from '@/components/util-components/ErrorBoundary'
import { BuildPassAuthProvider } from '@/context/authContext'
import { PreventSavingProvider } from '@/context/preventSavingContext'

type Props = {
  children?: React.ReactNode
}

export const ClerkAuthLayout: React.FC<Props> = ({ children }) => {
  return (
    <ClerkProvider
      signInUrl={'/sign-in'}
      signInFallbackRedirectUrl={'/dashboards/overview'}
    >
      <PreventSavingProvider>
        <ErrorBoundary>{children}</ErrorBoundary>
      </PreventSavingProvider>
    </ClerkProvider>
  )
}

export const SimpleAuthLayoutWithApollo = ({ children }) => {
  return (
    <BuildPassAuthProvider>
      <PreventSavingProvider>
        <ErrorBoundary>{children}</ErrorBoundary>
      </PreventSavingProvider>
    </BuildPassAuthProvider>
  )
}
